import React, { useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import PlotAreaCalculator from "../components/PlotAreaCalculator";
import AncillaryFactorCalculator from "../components/AncillaryFactorCalculator";
import styles from "../styles/BuiltUpAreaCalculator.module.css";
import styles1 from "../styles/UlcPremium.module.css";

const BuiltUpAreaCalculator = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [converterType, setConverterType] = useState("Built-up Area Calculator");

  const handleBack = () => navigate(-1);
  const handleNext = () => setStep(2);
  const handlePrev = () => setStep(1);

  const handleDropdownChange = (e) => {
    const selected = e.target.value;
    setConverterType(selected);
    const pathMap = {
      "Area Convertor": "/area-convertor",
      "Built-up Area Calculator": "/built-up-area-calculator",
      "Development Charges": "/development-charges",
      "Premium for Ancillary FSI": "/ancillary-fsi",
      "⁠Premium for Premium FSI": "/premium-fsi",
      "ULC Premium": "/ulc-premium",
    };
    if (pathMap[selected]) navigate(pathMap[selected]);
  };

  return (
    <div className={styles1.UlcPremium_container}>
      <div className={styles1.UlcPremium_header}>
        <button className={styles1.UlcPremium_backButton} onClick={handleBack}>
          <FaArrowLeft />
        </button>
        <h2 className={styles1.UlcPremium_title}>Conversion Calculator</h2>
      </div>

      <div className={styles1.UlcPremium_dropdownContainer}>
        <select
          value={converterType}
          onChange={handleDropdownChange}
          className={styles1.UlcPremium_mainDropdown}
        >
          <option>Area Convertor</option>
          <option>Built-up Area Calculator</option>
          <option>Development Charges</option>
          <option>Premium for Ancillary FSI</option>
          <option>⁠Premium for Premium FSI</option>
          <option>ULC Premium</option>
        </select>
      </div>

      {/* Form Sections */}
      <div className={styles.builtUpArea_formContainer}>
        {step === 1 && <PlotAreaCalculator onNext={handleNext} />}
        {step === 2 && <AncillaryFactorCalculator onPrev={handlePrev} />}
      </div>
    </div>
  );
};

export default BuiltUpAreaCalculator;
